const { log, error } = console

function loqsea(..._args: unknown[]) { }

// Usar import.meta.env.DEV para determinar modo desarrollo
// ya que contextoApp ya no está disponible en la capa base
const esDev = import.meta.env?.DEV ?? false

export const consolo = esDev
  ? console
  : {
    ...console,
    trulog: log,
    info: loqsea,
    log: loqsea,
    debug: loqsea,
    trace: loqsea,
    time: loqsea,
    timeEnd: loqsea,
    group: loqsea,
    groupEnd: loqsea,
    error
  }
